export default "__VITE_ASSET__Cov2XRvi__"